module.exports = __webpack_public_path__ + "static/monica-oltra-2-5c930b2d0e1048215b9a2aeefb043dfc.jpg";